function SectionContact() {
    return (
        <>
            <h4 className="section-head-small mb-4">Contact us</h4>
            <div className="twm-s-contact">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="form-group mb-3">
                            <input name="username" type="text" required className="form-control" placeholder="Name" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group mb-3">
                            <input name="email" type="text" className="form-control" required placeholder="Email" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group mb-3">
                            <input name="phone" type="text" className="form-control" required placeholder="Phone" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group mb-3">
                            <textarea name="message" className="form-control" rows={3} placeholder="Message" defaultValue={""} />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <button type="submit" className="site-button">Submit Now</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionContact;